export const config = {
  isTopCache: false,
  isAppSim: false,
  isSinglePageApp: false,
}
